import * as React from "react";
import type { SVGProps } from "react";
const SvgMeterMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <g clipPath="url(#Meter-Main_svg__a)">
      <path
        fill="#23F6E7"
        d="M2.666 2h10.667l1.333 2.667v10.095a.667.667 0 0 1-.666.667H2a.667.667 0 0 1-.667-.667V4.669zm10.51 2.667-.667-1.334H3.491l-.667 1.334z"
        opacity={0.8}
      />
      <g filter="url(#Meter-Main_svg__b)" opacity={0.6}>
        <path
          fill="#0535E4"
          fillRule="evenodd"
          d="M8.394 7.971V6.923c0-.194-.168-.351-.375-.351-.208 0-.376.157-.376.35v1.05c0 .193.168.35.376.35.207 0 .375-.157.375-.35m-2 .44-.296-1.006c-.054-.186.062-.384.261-.442.2-.058.404.045.459.231L7.113 8.2c.055.186-.062.384-.261.443s-.404-.046-.459-.232m-.834.835-.706-.776c-.13-.143-.112-.372.04-.512.154-.14.384-.136.514.007l.706.776c.13.143.112.372-.04.512-.154.14-.384.136-.514-.007m-.726.948-.893-.55c-.165-.1-.21-.326-.102-.502.108-.177.33-.238.495-.136l.893.55c.166.1.211.326.103.503-.109.176-.33.237-.496.135m2.888 3.274 1.549-3.331c.081-.176-.005-.39-.193-.477s-.406-.016-.488.16l-1.549 3.332c-.081.176.005.389.193.476.188.088.406.016.488-.16m-3.18-.965h-1.05c-.193 0-.35-.168-.35-.375 0-.208.157-.375.35-.375h1.05c.194 0 .35.167.35.375 0 .207-.157.375-.35.375m6.915 0h1.049c.194 0 .35-.168.35-.375 0-.208-.156-.375-.35-.375h-1.049c-.194 0-.35.167-.35.375 0 .207.156.375.35.375M4.54 11.47l-.974-.388c-.18-.072-.264-.286-.187-.479.076-.192.284-.29.464-.218l.975.388c.18.072.263.286.187.479-.077.192-.285.29-.465.218m7.895-.388-.974.388c-.18.072-.388-.026-.465-.218-.076-.193.007-.407.187-.479l.974-.388c.18-.072.388.026.465.218.077.193-.007.407-.187.479m-.376-1.437-.894.55c-.165.1-.386.04-.495-.136s-.063-.402.102-.504l.894-.549c.165-.102.386-.04.495.136s.063.401-.102.503m-.913-1.175-.706.776c-.13.143-.36.146-.513.007-.154-.14-.172-.369-.042-.512l.706-.776c.13-.143.36-.146.514-.007.153.14.172.369.041.512M9.97 7.405l-.295 1.006c-.055.187-.26.29-.459.232-.199-.059-.315-.257-.26-.443l.294-1.006c.055-.186.26-.29.459-.231s.316.256.261.442"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Meter-Main_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
      <filter
        id="Meter-Main_svg__b"
        width={47.515}
        height={44.894}
        x={-5.758}
        y={-2.328}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={10} dy={10} />
        <feGaussianBlur stdDeviation={9.45} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.462745 0 0 0 0 0.556863 0 0 0 0 0.690196 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2257_4435"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2257_4435"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgMeterMain;
